import { type FC, type ReactNode } from "react"

import { cn, tw } from "@forento/ui/utilities/tailwind"

import LoadingIndicator from "~/components/LoadingIndicator"

export const containerClasses = tw`border-component-border hover:border-primary/20 flex items-center justify-between gap-4 rounded-xl border bg-white p-4 transition-colors`
export const titleClasses = tw`font-semibold text-gray-900`
export const tagsClasses = tw`flex flex-wrap items-center gap-4`

type AccessButtonProps = { isDanger?: boolean; isLoading?: boolean; onClick(): void; children: ReactNode }
export const AccessButton: FC<AccessButtonProps> = ({ isDanger, isLoading, onClick, children }) => (
	<button
		type="button"
		disabled={isLoading}
		onClick={onClick}
		className={cn(
			"bg-primary hover:bg-primary/80 focus-visible:outline-primary flex cursor-pointer items-center gap-2 rounded-lg px-4 py-2 text-sm leading-none font-semibold text-white transition-colors focus-visible:outline-2 focus-visible:outline-offset-2",
			isDanger && "bg-danger",
		)}
	>
		{isLoading && <LoadingIndicator className="size-3" color="white" />}
		{children}
	</button>
)

type TagProps = { color: "blue" | "green" | "orange"; children: ReactNode }
export const Tag: FC<TagProps> = ({ color, children }) => (
	<div
		className={cn(
			"rounded-xl px-3 py-1.5 text-xs leading-none font-semibold",
			color === "blue" && "border border-blue-200 bg-blue-50 text-blue-600",
			color === "green" && "border border-green-200 bg-green-50 text-green-600",
			color === "orange" && "border border-orange-200 bg-orange-50 text-orange-600",
		)}
	>
		{children}
	</div>
)
